<template lang="pug">

  .new-user-promotion-component

    template(v-if="isAlreadySubmitted")
      slot(name="submitted")
        .resend-button
          new-user-promotion-resend-button Resend email

    template(v-else="")
      slot(name="form")
        .form
          new-user-promotion-form

      template(v-if="isJustSubmitted")
        slot(name="success")
          .email
            new-user-promotion-email
          .resend-button
            new-user-promotion-resend-button Resend email

</template>

<script>
import Cookies from 'js-cookie'

const EMAIL_COOKIE_NAME = 'new-user-promotion-email';

const SOURCE_QUERY_PARAM = 'utm_source';

export default {
  name: 'new-user-promotion',

  data: () => ({
    visit: null,
    email: null,
    isJustSubmitted: false,
    isAlreadySubmitted: false
  }),

  created() {
    this.$store.dispatch('trackVisit', { source: this.$route.query[SOURCE_QUERY_PARAM] });

    this.$on('reset', this.reset);
    this.$on('just-submitted', this.justSubmitted);
    this.$on('already-submitted', this.alreadySubmitted);

    const email = Cookies.get(EMAIL_COOKIE_NAME);

    if (email) {
      this.email = email;
      this.isAlreadySubmitted = true;
    }
  },

  methods: {
    setEmail(email) {
      Cookies.set(EMAIL_COOKIE_NAME, email, { expires: 365 });
      this.email = email;
    },

    reset() {
      this.email = null;
      this.isJustSubmitted = false;
      this.isAlreadySubmitted = false;

      Cookies.remove(EMAIL_COOKIE_NAME);
    },

    justSubmitted(email) {
      this.setEmail(email);
      this.isJustSubmitted = true;
    },

    alreadySubmitted(email) {
      this.setEmail(email);
      this.isAlreadySubmitted = true;
    }
  }
}
</script>
